import { getProfileAction } from '@/actions/user/get-profile-action'
import { mapUserDataForEnhancedMatch } from '@/components/@analitycs/map-user-data-for-enhanced-match'
import type { EnhancedMatchUserData } from '@/components/@analitycs/push-ecommerce-event'

/**
 * Retorna os dados do usuário logado para os eventos de analytics,
 * ou `undefined` quando não há sessão ou o perfil não pôde ser carregado.
 * Os valores seguem sem hash: o Google aplica o SHA-256 no envio.
 */
export async function getLoggedUserData(): Promise<
  EnhancedMatchUserData | undefined
> {
  try {
    const { data: profileResult } = await getProfileAction()
    const profile = profileResult?.data

    if (!profile) {
      return undefined
    }

    return mapUserDataForEnhancedMatch({
      fullName: profile.full_name,
      email: profile.email,
      phone: profile.phone_number,
      city: profile.address?.city,
      state: profile.address?.state,
      zip: profile.address?.zipcode,
      country: profile.address?.country,
    })
  } catch {
    return undefined
  }
}
